import Location from './Location';

export default class Supply extends Location {

	constructor (master) {

		super(master, "supply");
	}
}